export const QueryGroupMemberInFolderApi = Symbol.for('QueryGroupMemberInFolderApi');
